export const upload = {
  sizeLimit: 120000000,
}

export default upload
